import { Sun, Moon } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

/**
 * Floating theme toggle for unauthenticated marketing/auth surfaces.
 * Position is parent-controlled (default: top-right inside a `relative` parent).
 *
 * Usage:
 *   <ThemeToggleButton />                       // absolute top-right
 *   <ThemeToggleButton position="static" />     // inline (no positioning)
 */
export default function ThemeToggleButton({ position = "absolute" }) {
  const { theme, toggle } = useTheme();
  const positionCls =
    position === "absolute" ? "absolute top-5 right-5 z-50" : "";
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      title={theme === "dark" ? "Switch to light mode" : "Switch to dark mode"}
      data-testid="theme-toggle-button"
      className={`${positionCls} inline-flex items-center justify-center w-9 h-9 rounded-md border transition-colors`}
      style={{
        borderColor: "var(--bf-line-medium)",
        background: "var(--bf-surface)",
        color: "var(--bf-fg-muted)",
      }}
    >
      {theme === "dark" ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
